
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/
export const form   =  [
 
	{	
		name: "code", 
		value:'', 		
		id:'clientPurchase_form_code',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "provider_id", 
		value:[],
		valueFull:'', 		
		id:'clientPurchase_form_provider_id',
		html:'',
		type:'autocomplete',
		required: true,  
	},
	{	
		name: "shipping", 
		value:'', 		
		id:'clientPurchase_form_shipping',
		html:'',
		type:'multiselect',
		options :["ordered", "shipped", "delivered"],
		required: false,  
	},
	
	{	
		name: "reference_number", 
		value:'', 		
		id:'clientPurchase_form_reference_number',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "purchase_date", 
		value:'0000-00-00',
		date: true,		
		id:'clientPurchase_form_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "due_date", 
		value:'0000-00-00',
		date: true,	
		id:'clientPurchase_form_due_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "bill_date", 
		value:'0000-00-00',
		date: true,	
		id:'clientPurchase_form_bill_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "delivered_date", 
		value:'0000-00-00',
		date: true,	
		id:'clientPurchase_form_delivered_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "general_total_expenses", 
		value:'', 		
		id:'clientPurchase_general_total_expenses',
		html:'',
		type:'textfield',
		required: false,  
	},
	// {	
	// 	name: "general_total_price", 
	// 	value:'', 		
	// 	id:'clientPurchase_general_total_price',
	// 	html:'',
	// 	type:'textfield',
	// 	required: false,  
	// },

	
	
]

//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form)) 

